// extracted by mini-css-extract-plugin
module.exports = {"ra-additional-services":"ra-additional-services_ra-additional-services__2Bd3d","ra-additional-services__cards":"ra-additional-services_ra-additional-services__cards__yChi4"};